import { PlusIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Input from "../../../../components/input";
import Container from "../../../../components/container";
import { addChild, State } from "../actions/children";
import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { PhysicalAndMentalSymptomViewModel } from "../../../../viewModels";

export default function CreateChildForm({
  parent,
}: {
  parent: PhysicalAndMentalSymptomViewModel;
}) {
  const navigate = useNavigate();    
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };

  const [state, formAction, isPending] = useActionState(
    addChild,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/physical-and-mental-symptoms/edit/${parent.id}?reload=${Date.now()}`);
      toast.success("Symptom added successfully");
    }
  }, [state]);

  return (
    <form action={formAction} className="flex gap-2 w-full ">
      <Input
        className="w-full"
        name="name"
        id="name"
        placeholder="Name"
        required={true}
      ></Input>
      <input
        type="hidden"
        id="parentId"
        name="parentId"
        value={parent.id}
      ></input>
      <IconButton label="Add Symptom" icon={PlusIcon} loading={isPending}></IconButton>
    </form>
  );
}
